var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WidgetToolbox'),_c('BgEditable',[_c('header',[_c('nav',{staticClass:"navbar navbar-expand justify-content-center"},[_c('ImageEditable',{attrs:{"name":"logo","partData":_vm.touchedData.logo}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }